<template>
    <div class="row justify-content-center" :class="wrapperClass">
        <nav>
            <ul class="pagination-redesign">
                <li>
                    <button :disabled="page <= 1"
                            @click.prevent="decreasePage"
                    >‹
                    </button>
                </li>

                <li v-for="pageNumber in leftSection"
                    :key="'left-' + pageNumber"
                    :class="{'active': page === pageNumber}">
                    <button v-if="page !== pageNumber"
                            @click.prevent="setPage(pageNumber)">
                        {{ pageNumber }}
                    </button>
                    <span v-else>{{ pageNumber }}</span>
                </li>

                <li v-if="showEllipsis" class="ellipsis">
                    <span>...</span>
                </li>

                <li v-for="pageNumber in rightSection"
                    :key="'right-' + pageNumber"
                    :class="{'active': page === pageNumber}">
                    <button v-if="page !== pageNumber"
                            @click.prevent="setPage(pageNumber)">
                        {{ pageNumber }}
                    </button>
                    <span v-else>{{ pageNumber }}</span>
                </li>

                <li e2e-id="search-results-next-page">
                    <button :disabled="page >= totalPages"
                            @click.prevent="increasePage"
                    >›
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
const SECTION_ITEM_COUNT = 3;
const PAGE_BUFFER = SECTION_ITEM_COUNT - 1;

function arrayRange(start, end) {
    const result = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result;
}

function setPage(pageNumber) {
    if (pageNumber < 1 || pageNumber > this.totalPages) {
        return;
    }
    this.$emit('changePage', pageNumber);
}

function decreasePage() {
    if (this.page <= 1) {
        return;
    }
    this.setPage(this.page - 1);
}

function increasePage() {
    if (this.page >= this.totalPages) {
        return;
    }
    this.setPage(this.page + 1);
}

export default {
    props: {
        currentPage: {
            type: [String, Number],
            required: true
        },
        lastPage: {
            type: [String, Number],
            required: true
        },
        wrapperClass: {
            type: String,
            default: 'm-3'
        }
    },
    computed: {
        page() {
            return Number(this.currentPage) || 1;
        },
        totalPages() {
            return Number(this.lastPage) || 1;
        },
        startPageNumberForLeftSection() {
            if (this.totalPages > 1) {
                return this.page - 1;
            }
            return 1;
        },
        startPageNumberForRightSection() {
            if (this.totalPages > SECTION_ITEM_COUNT && this.totalPages < SECTION_ITEM_COUNT * 2) {
                return SECTION_ITEM_COUNT + 1;
            }
            return this.totalPages - PAGE_BUFFER;
        },
        isPreviousTwoPagesExists() {
            return this.startPageNumberForLeftSection >= PAGE_BUFFER;
        },
        leftSection() {
            if (this.totalPages <= 0) {
                return [1];
            }

            if (this.totalPages <= SECTION_ITEM_COUNT) {
                return arrayRange(1, this.totalPages);
            }

            const nextPage = this.page + 1;
            const leftSectionPages = arrayRange(this.startPageNumberForLeftSection, this.page + 1);

            if (!this.isPreviousTwoPagesExists || this.rightSection.includes(this.page)) {
                return arrayRange(1, SECTION_ITEM_COUNT);
            }

            const bothSectionsIncludeNextPage = leftSectionPages.includes(nextPage) && this.rightSection.includes(nextPage);
            if (this.isPreviousTwoPagesExists && bothSectionsIncludeNextPage) {
                return arrayRange(this.startPageNumberForLeftSection - 1, this.page);
            }

            if (this.isPreviousTwoPagesExists) {
                return leftSectionPages;
            }

            return [1];
        },
        rightSection() {
            if (this.totalPages <= SECTION_ITEM_COUNT) {
                return [];
            }
            return arrayRange(this.startPageNumberForRightSection, this.totalPages);
        },
        showEllipsis() {
            return this.totalPages > SECTION_ITEM_COUNT;
        }
    },
    methods: {
        setPage,
        decreasePage,
        increasePage
    }
}
</script>
